<template>

  <div ref="refRoot" class="tes-masonry-posts__list">

    <div :class="['tes-masonry-posts__item',`tes-masonry-posts__item_${index}`,'tes-masonry-posts__item_post']"
         v-for="(item, index) in items">

      <figure class="tes-masonry-posts__item-picture-container tes-picture__container tes-picture__container_loading"
              v-if="item.image()">

        <router-link class="tes-masonry-posts__item-picture-link tes-picture__link"
                     :to="item.tid() ? {name: 'BlogPost', params: {tid: item.tid()}} : '/'"
                     :title="`ссылка на статью: «${item.header()}»`">

          <LazyLoadPicture
            pictureClass="tes-masonry-posts__item-picture tes-picture__wrapper"
            imageClass="tes-masonry-posts__item-picture-image tes-article__picture-image tes-picture__image"
            :image="item.image()"
            :altEmpty="item.header()"
            imageItemprop="url contentUrl"
            :variants="item.imageVariants()"/>

        </router-link>
      </figure>

      <div class="tes-masonry-posts__item-content">
        <h3 class="tes-masonry-posts__item-head" v-if="item.tid()">
          <router-link :to="item.tid() ? {name: 'BlogPost', params: {tid: item.tid()}} : '/'"
                       class="tes-masonry-posts__item-head-link">{{ item.header() }}
          </router-link>
        </h3>
      </div>

      <router-link
        class="tes-masonry-posts__item-link_overlay"
        :to="item.tid() ? {name: 'BlogPost', params: {tid: item.tid()}} : '/'"
        :title="`ссылка на статью: «${item.header()}»`"
      ><span class="not-for-anyone" v-html="item.header()"></span></router-link>

    </div>

    <div class="tes-masonry-posts__item tes-masonry-posts__item_banner">
      <figure class="tes-masonry-posts__item-picture-container tes-picture__container">
          <span class="tes-picture__overlay">
            <PuffSpinner class="tes-picture__spinner"/>
          </span>

        <a href="//tion.ru/product/breezer/"
           class="tes-masonry-posts__item-picture-link tes-picture__link"
           title="сылка на акцию">


          <picture class="tes-masonry-posts__item-picture tes-picture__wrapper">
            <!-- source srcset="/src/assets/bpage/tile-3-mini-8.jpg?webp" -->
            <img src="https://vapt-storage.storage.yandexcloud.net/images/2021/12/tile-3-mini-8.jpg"
                 width="732" height="253"
                 alt=""
                 class="tes-masonry-posts__item-picture-image tes-article__picture-image tes-picture__image">
          </picture>

        </a>
      </figure>
      <a
        class="tes-masonry-posts__item-link_overlay"
        href="https://tion.ru/product/breezer/"
         title="ссылка на акцию"><h3 class="not-for-anyone">ссылка на акцию</h3></a>
    </div>

    <EllipsisLoader :loading="loading"/>

  </div>

</template>

<script lang="ts">
import {MediaVariantData} from '../../objects/MediaVariant'
import PostListItem, {PostListItemData} from '../../objects/post/PostListItem'
import Pagination, {PaginationData} from '../../objects/Paginator'
import {PostTagData} from '../../objects/post/PostTag'

import {defineComponent, onMounted, ref} from 'vue'
import {useStore} from 'vuex'

import PuffSpinner from '~/assets/loaders/puff.svg'


export default defineComponent({
  name: 'MasonryLastPostsView',
  components: {
    PuffSpinner
  },
  setup() {
    const store = useStore()
    const refRoot = ref()
    const loading = ref(false)
    const items = ref([] as Array<PostListItem>)

    const pagination = ref(
      new Pagination({per_page: 7, current_page: 1} as PaginationData)
    );

    // готовит пустые данные
    const generate = () => {
      for (let i = 0; i < pagination.value.perPage(); i++) {
        items.value.push(new PostListItem(
          {tags: [] as Array<PostTagData>, image_variants: [] as Array<MediaVariantData>} as PostListItemData
        ))
      }
    }

    // обновляет данные одного элемента
    // после загрузки навешивает обсерв на элементы
    // загружает данные
    const load = async () => {
      loading.value = true;
      try {
        let data = await store.dispatch(
            'posts/loadDataForListOfGroupedPost',
            {
              props: {media: 'masonry_3'},
              paginator: {per_page: 7, current_page: 1},
              sort: ['updated_at,desc'],
              filter: null
            },
            {root: true}
          )
        data.data.forEach((item, idx) => items.value[idx] = new PostListItem(item as PostListItemData))
      } catch (error) {
        console.log(error)
      }
      loading.value = false
    }


    onMounted(() => {
      generate()
      let options = {root: null, threshold: 0}
      let observer = new IntersectionObserver((entities, observer) => {
        entities.forEach((entity) => {
          if (!entity.isIntersecting) {
            return
          }
          observer.unobserve(refRoot.value) // прекращаем следить за элементом
          load();//загружаем его
        })
      }, options)
      observer.observe(refRoot.value)
    })

    return {refRoot, loading, items}
  }
})
</script>

<style lang="scss">
.tes-masonry-posts {

  &__list {
    position: relative;
    display: flex;
    flex-wrap: wrap;
    flex-direction: row;
    justify-content: center;
    padding: 0;
    max-width: 100%;

    @media (max-width: 1200px) {
      max-width: 960px;
    }
    @media (max-width: 768px) {
      max-width: 750px;
      margin: auto;
      padding: 0;
    }
    @media (max-width: 576px) {
      flex-direction: column;
      max-width: 100%;
      margin: auto;
      padding: 0;
    }
  }

  &__item {
    width: 358px;
    height: 255px;
    margin-right: 10px;
    margin-bottom: 14px;

    position: relative;
    backface-visibility: hidden;
    text-align: left;
    overflow: hidden;
    display: inline-block;
    cursor: pointer;

    @media(max-width: 1200px) {
      width: 300px;
      height: 238px;
      margin-right: 10px;
      margin-bottom: 14px;
    }

    @media(max-width: 768px) {
      width: 100%;
      height: auto;
      margin: 0 0 15px;
      aspect-ratio: $postAspectRatio;
    }

    &-link_overlay {
      position: absolute;
      z-index: 11;
      top: 0;
      bottom: 0;
      right: 0;
      left: 0;
    }

    &:nth-child(2n) {
      @media(max-width: 992px) {
        margin-right: 0;
      }
    }

    &:nth-child(3n) {
      @media(min-width: 992px) {
        margin-right: 0;
      }
    }

    &_0 {
    }

    &_1 {
    }

    &_2 {
    }

    &_3 {
    }

    &_4 {
    }

    &_5 {
    }

    &_6 {
      @media(max-width: 992px) {
        display: none;
      }
    }

    &_post {
    }

    &_banner {
      width: 726px;
      max-width: 726px;
      height: 255px;
      max-height: 255px;
      margin: 0;

      @media(max-width: 1200px) {
        width: 610px;
        max-width: 610px;
        height: 238px;
        max-height: 238px;
      }
      @media (max-width: 992px) {
        margin: 0 10px 0 0;
      }
      @media(max-width: 768px) {
        width: 100%;
        max-width: none;
        height: auto;
        max-height: none;
        margin: 0 0 15px;
        //aspect-ratio: $postAspectRatio;
      }
    }

    &-content {
      width: 100%;
      position: absolute;
      bottom: 0;
      left: 0;
      padding: 15px;
      overflow: hidden;
      z-index: 10;
      color: #fff;
    }

    &-head a,
    &-head {
      font-size: 18px;
      font-weight: 400;
      line-height: 21px;
      color: #fff;
    }

    &-picture-container {
      height: 100%;
    }

    &-picture-image {
      width: auto;
      max-width: none;
      height: 100%;
      max-height: none;
      object-fit: cover;
      transition: transform .3s ease-in-out;
    }

    &:after {
      content: '';
      display: block;
      position: absolute;
      width: 100%;
      height: 100%;
      top: 0;
      left: 0;
      background: #000;
      opacity: 0.15;
      transition: opacity 250ms;
    }

    &:before {
      content: '';
      display: block;
      position: absolute;
      bottom: 0;
      width: 100%;
      height: 45%;
      background: linear-gradient(to bottom, rgba(0, 0, 0, 0) 0%, #000 100%);
      opacity: 0.66;
      z-index: 1;
    }

    &:hover {
      &:after {
        opacity: 0.5;
      }

      .tes-masonry-posts__item-picture-image {
        transform: scale(1.10);
      }
    }
  }
}
</style>
